/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsTimeRangeFilter extends models.AppSecopsFilter {
    getFixupPrototypeFunction() { return AppSecopsTimeRangeFilter.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsTimeRangeFilter>): AppSecopsTimeRangeFilter {
        let obj = Object.assign(new AppSecopsTimeRangeFilter(), model);
        AppSecopsTimeRangeFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsTimeRangeFilter>): AppSecopsTimeRangeFilter {
        if (!model) return null;
        return AppSecopsTimeRangeFilter.newInstance(<AppSecopsTimeRangeFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsTimeRangeFilter) {
        if (!obj) return;

        models.AppSecopsTimeRangeFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsTimeRangeFilter): boolean {
        if (models.AppSecopsFilter.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsTimeRangeFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
    }

    /**
     * Start date of the time period
     */
    start_date: Date;

    /**
     * End date of the time period
     */
    end_date: Date;

}
